import { useSelector } from '@legendapp/state/react';
import { store$, setDiscountTimer as setTimer } from './store';

export const useDiscountTimer = () => {
  const targetTime = useSelector(store$.discountTimer.targetTime);

  return {
    targetTime,
    setDiscountTimer: setTimer,
  };
};

export const useDiscountTimerObservable = () => store$.discountTimer.targetTime;

export const useIsDiscountExpired = () => {
  const targetTime = useSelector(store$.discountTimer.targetTime);
  const now = Date.now();

  return now >= targetTime;
};

export const useDiscountTimeRemaining = () => {
  const targetTime = useSelector(store$.discountTimer.targetTime);
  const now = Date.now();
  const remaining = targetTime - now;

  return Math.max(0, remaining);
};
